import { MutationOptions, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import UserMissionRepository from '@/repositories/UserMissionRepository';
import type { AssignUserMissionPayload, UserMission, UserMissionState } from '@/types/userMission';

import useAPI from './useAPI';

export const USER_MISSIONS_QUERY_KEY = 'getUserMissions';

export const useUserMissions = (personId: string, state: UserMissionState, page = 1) => {
  const repository = UserMissionRepository();

  return useAPI({
    queryKey: [USER_MISSIONS_QUERY_KEY, personId, state, page],
    queryFn: async () => repository.list({ personId, state, page }),
    enabled: !!personId,
    keepPreviousData: true
  });
};

export const useMissionCatalog = (personId: string, enabled: boolean) => {
  const repository = UserMissionRepository();

  return useAPI({
    queryKey: ['getMissionCatalog', personId],
    queryFn: async () => repository.catalog(personId),
    enabled: enabled && !!personId
  });
};

export const useUserMissionStats = (personId: string, enabled: boolean) => {
  const repository = UserMissionRepository();

  return useAPI({
    queryKey: [USER_MISSIONS_QUERY_KEY, personId, 'stats'],
    queryFn: async () => repository.stats(personId),
    enabled: enabled && !!personId
  });
};

export const useAssignUserMission = (
  options?: MutationOptions<UserMission, AxiosError, AssignUserMissionPayload>
) => {
  const repository = UserMissionRepository();

  return useMutation({
    mutationFn: (data: AssignUserMissionPayload) => repository.assign(data),
    ...options
  });
};
